<template>
  <div class="common-test">
    <el-tabs v-model="activeTab" type="border-card">
      <!-- 测试通用配置标签页 -->
      <el-tab-pane label="测试通用配置" name="config">
        <el-card>
          <div class="common-test__title">测试通用配置</div>
          <div class="common-test__subtitle">actor config 更新</div>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="用户rid:">
              <el-input v-model="form.rid"></el-input>
            </el-form-item>
            <el-form-item label="key:">
              <el-input v-model="form.key"></el-input>
            </el-form-item>
            <el-form-item label="value:">
              <el-input v-model="form.value"></el-input>
            </el-form-item>
            <el-form-item label="valueInt:">
              <el-input v-model="form.valueInt"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :loading="loading">更新</el-button>
              <el-button type="danger" @click="onDelete" :loading="loading">删除</el-button>
              <el-button @click="onClear" :loading="loading">清除数据</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

      <!-- 首充状态管理标签页 -->
      <el-tab-pane label="首充状态管理" name="firstRecharge">
        <el-card>
          <div class="common-test__title">首充状态管理</div>
          <div class="common-test__subtitle">首充状态查询和重置</div>
          <el-form ref="firstRechargeForm" :model="firstRechargeForm" label-width="80px">
            <el-form-item label="用户rid:">
              <el-input v-model="firstRechargeForm.rid" placeholder="请输入用户rid"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onQueryFirstRecharge" :loading="firstRechargeLoading">查询首充状态</el-button>
              <el-button type="warning" @click="onResetFirstRecharge" :loading="firstRechargeLoading">重置首充状态</el-button>
              <el-button @click="onClearFirstRecharge" :loading="firstRechargeLoading">清除数据</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

      <!-- 主播淘汰考核管理标签页 -->
      <el-tab-pane label="主播淘汰考核管理" name="assessment">
        <el-card>
          <div class="common-test__title">主播淘汰考核管理</div>
          <div class="common-test__subtitle">批量修改主播评级分数</div>
          <el-form ref="assessmentForm" :model="assessmentForm" label-width="120px">
            <el-form-item label="主播rid:">
              <el-input v-model="assessmentForm.rid" placeholder="请输入主播rid"></el-input>
            </el-form-item>
            <el-form-item label="考核阶段:" required>
              <el-select v-model="assessmentForm.assessmentType" placeholder="请选择考核阶段" style="width: 100%;">
                <el-option label="第一阶段" value="1"></el-option>
                <el-option label="第二阶段" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分数记录:">
              <div v-for="(item, index) in assessmentForm.scoreLogUpdateDTOList" :key="index" style="margin-bottom: 10px;">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-input-number 
                      v-model="item.score" 
                      :min="0" 
                      :max="100" 
                      placeholder="分数(0-100)"
                      style="width: 100%;">
                    </el-input-number>
                  </el-col>
                  <el-col :span="12">
                    <el-date-picker
                      v-model="item.date"
                      type="date"
                      :placeholder="index === 0 ? '选择起始日期' : '自动生成'"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :disabled="index > 0"
                      @change="onFirstDateChange"
                      style="width: 100%;">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="4" v-if="index === 0">
                    <el-button type="danger" size="small" @click="removeScoreLog">删除</el-button>
                  </el-col>
                </el-row>
              </div>
              <el-button 
                type="primary" 
                size="small" 
                @click="addScoreLog"
                :disabled="assessmentForm.scoreLogUpdateDTOList.length >= 7">
                添加分数记录
              </el-button>
              <span style="margin-left: 10px; color: #909399; font-size: 12px;">
                需要填写连续7天的分数记录
              </span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onBatchUpdateAppraiseScore" :loading="assessmentLoading">批量修改分数</el-button>
              <el-button @click="onClearAssessment" :loading="assessmentLoading">清除数据</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

      <!-- 主播淘汰考核状态重置标签页 -->
      <el-tab-pane label="考核状态重置" name="resetAssessment">
        <el-card>
          <div class="common-test__title">主播淘汰考核状态重置</div>
          <div class="common-test__subtitle">重置主播淘汰考核状态</div>
          <el-form ref="resetAssessmentForm" :model="resetAssessmentForm" label-width="120px">
            <el-form-item label="主播rid:">
              <el-input v-model="resetAssessmentForm.rid" placeholder="请输入主播rid"></el-input>
            </el-form-item>
            <el-form-item label="考核阶段:">
              <el-select v-model="resetAssessmentForm.assessmentType" placeholder="请选择考核阶段" style="width: 100%;">
                <el-option label="第一阶段" :value="1"></el-option>
                <el-option label="第二阶段" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考核日期:">
              <el-date-picker
                v-model="resetAssessmentForm.assessmentResultDate"
                type="date"
                placeholder="选择考核日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="warning" @click="onResetAssessmentCycleResult" :loading="resetAssessmentLoading">重置考核状态</el-button>
              <el-button @click="onClearResetAssessment" :loading="resetAssessmentLoading">清除数据</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>

      <!-- 修改用户来源标签页 -->
      <el-tab-pane label="修改用户来源" name="userSource">
        <el-card>
          <div class="common-test__title">修改用户来源</div>
          <div class="common-test__subtitle">修改用户的推广来源和推广媒介</div>
          <el-form ref="userSourceForm" :model="userSourceForm" label-width="120px">
            <el-form-item label="用户rid:">
              <el-input v-model="userSourceForm.rid" placeholder="请输入用户rid"></el-input>
            </el-form-item>
            <el-form-item label="推广来源:">
              <el-input v-model="userSourceForm.source" placeholder="请输入推广来源"></el-input>
            </el-form-item>
            <el-form-item label="推广媒介:">
              <el-input v-model="userSourceForm.medium" placeholder="请输入推广媒介"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onUpdateUserSource" :loading="userSourceLoading">修改来源</el-button>
              <el-button @click="onClearUserSource" :loading="userSourceLoading">清除数据</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'CommonTest',
  data() {
    return {
      activeTab: 'config', // 当前激活的标签页
      form: {
        rid: '',
        key: '',
        value: '',
        valueInt: ''
      },
      loading: false,
      firstRechargeForm: {
        rid: ''
      },
      firstRechargeLoading: false,
      assessmentForm: {
        rid: '',
        assessmentType: '',
        scoreLogUpdateDTOList: []
      },
      assessmentLoading: false,
      resetAssessmentForm: {
        rid: '',
        assessmentType: '',
        assessmentResultDate: ''
      },
      resetAssessmentLoading: false,
      userSourceForm: {
        rid: '',
        source: '',
        medium: ''
      },
      userSourceLoading: false
    }
  },
  methods: {
    async onSubmit() {
      if (this.loading) return
      if (!this.form.rid && !this.form.key && !this.form.value && !this.form.valueInt) return
      this.loading = true
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.actor_config_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ...this.form,
        },
      })
      this.loading = false
      if (res.code === 0 || res.status === 0) {
        this.$message.success('更新成功')
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    async onDelete() {
      if (this.loading) return
      if (!this.form.rid && !this.form.key && !this.form.value && !this.form.valueInt) return
      this.$confirm('确认进行删除操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        const { data: res } = await this.$axios({
          method: 'post',
          url: this.$store.getters.path.actor_config_delete,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            ...this.form,
          },
        })
        this.loading = false
        if (res.code === 0 || res.status === 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.msg || res.message)
        }
      }).catch(() => { })
    },
    onClear() {
      this.form = this.$options.data().form
    },
    async onQueryFirstRecharge() {
      if (this.firstRechargeLoading) return
      if (!this.firstRechargeForm.rid) {
        this.$message.warning('请输入用户rid')
        return
      }
      this.firstRechargeLoading = true
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.query_first_recharge_status,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          rid: this.firstRechargeForm.rid,
        },
      })
      this.firstRechargeLoading = false
      if (res.code === 0) {
        if(res.data){
          this.$message.success('该用户有首充资格')
        } else {
          this.$message.warning('该用户没有首充资格')
        }
      } else {
        this.$message.error(res.msg || res.message || '查询失败')
      }
    },
    async onResetFirstRecharge() {
      if (this.firstRechargeLoading) return
      if (!this.firstRechargeForm.rid) {
        this.$message.warning('请输入用户rid')
        return
      }
      this.$confirm('确认重置该用户的首充状态吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.firstRechargeLoading = true
        const { data: res } = await this.$axios({
          method: 'post',
          url: this.$store.getters.path.reset_first_recharge_status,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            rid: this.firstRechargeForm.rid,
          },
        })
        this.firstRechargeLoading = false
        if (res.code === 0) {
          this.$message.success('首充资格已重置')
        } else {
          this.$message.error(res.msg || res.message || '重置失败')
        }
      }).catch(() => { })
    },
    onClearFirstRecharge() {
      this.firstRechargeForm = this.$options.data().firstRechargeForm
    },
    // 主播淘汰考核管理相关方法
    addScoreLog() {
      // 如果列表为空，添加第一个日期
      if (this.assessmentForm.scoreLogUpdateDTOList.length === 0) {
        this.assessmentForm.scoreLogUpdateDTOList.push({
          score: 0,
          date: ''
        })
      } else {
        // 如果已有记录，自动生成后续日期
        this.generateConsecutiveDates()
      }
    },
    // 生成连续7个日期
    generateConsecutiveDates() {
      const firstDate = this.assessmentForm.scoreLogUpdateDTOList[0]?.date
      if (!firstDate) {
        this.$message.warning('请先选择起始日期')
        return
      }
      
      // 清空现有列表，重新生成7个连续日期
      this.assessmentForm.scoreLogUpdateDTOList = []
      const startDate = new Date(firstDate)
      
      for (let i = 0; i < 7; i++) {
        const currentDate = new Date(startDate)
        currentDate.setDate(startDate.getDate() + i)
        const dateStr = this.formatDate(currentDate)
        
        this.assessmentForm.scoreLogUpdateDTOList.push({
          score: 0,
          date: dateStr
        })
      }
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 第一个日期改变时，自动生成后续6个日期
    onFirstDateChange(date) {
      if (!date) {
        // 如果清空了第一个日期，清空所有记录
        this.assessmentForm.scoreLogUpdateDTOList = []
        return
      }
      
      // 生成连续7个日期
      this.generateConsecutiveDates()
    },
    removeScoreLog() {
      // 删除所有记录
      this.assessmentForm.scoreLogUpdateDTOList = []
    },
    async onBatchUpdateAppraiseScore() {
      if (this.assessmentLoading) return
      if (!this.assessmentForm.rid) {
        this.$message.warning('请输入主播rid')
        return
      }
      if (!this.assessmentForm.assessmentType) {
        this.$message.warning('请选择考核阶段')
        return
      }
      if (this.assessmentForm.scoreLogUpdateDTOList.length === 0) {
        this.$message.warning('请添加分数记录')
        return
      }
      if (this.assessmentForm.scoreLogUpdateDTOList.length !== 7) {
        this.$message.warning('必须填写连续7天的分数记录')
        return
      }
      
      // 验证数据
      for (let item of this.assessmentForm.scoreLogUpdateDTOList) {
        if (item.score < 0 || item.score > 100) {
          this.$message.warning('分数必须在0-100之间')
          return
        }
        if (!item.date) {
          this.$message.warning('日期不能为空')
          return
        }
      }
      
      // 验证日期是否连续
      for (let i = 1; i < this.assessmentForm.scoreLogUpdateDTOList.length; i++) {
        const prevDate = new Date(this.assessmentForm.scoreLogUpdateDTOList[i - 1].date)
        const currentDate = new Date(this.assessmentForm.scoreLogUpdateDTOList[i].date)
        const diffDays = Math.floor((currentDate - prevDate) / (1000 * 60 * 60 * 24))
        if (diffDays !== 1) {
          this.$message.warning('日期必须连续')
          return
        }
      }

      this.$confirm('确认批量修改主播评级分数吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.assessmentLoading = true
        const { data: res } = await this.$axios({
          method: 'post',
          url: this.$store.getters.path.batch_update_appraise_score,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            rid: parseInt(this.assessmentForm.rid),
            assessmentType: this.assessmentForm.assessmentType,
            scoreLogUpdateDTOList: this.assessmentForm.scoreLogUpdateDTOList
          },
        })
        this.assessmentLoading = false
        if (res.code === 0) {
          this.$message.success('批量修改分数成功')
        } else {
          this.$message.error(res.msg || res.message || '批量修改分数失败')
        }
      }).catch(() => { })
    },
    onClearAssessment() {
      this.assessmentForm = this.$options.data().assessmentForm
    },
    async onResetAssessmentCycleResult() {
      if (this.resetAssessmentLoading) return
      if (!this.resetAssessmentForm.rid) {
        this.$message.warning('请输入主播rid')
        return
      }
      if (!this.resetAssessmentForm.assessmentType) {
        this.$message.warning('请选择考核阶段')
        return
      }
      if (!this.resetAssessmentForm.assessmentResultDate) {
        this.$message.warning('请选择考核日期')
        return
      }

      this.$confirm('确认重置主播淘汰考核状态吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.resetAssessmentLoading = true
        const { data: res } = await this.$axios({
          method: 'post',
          url: this.$store.getters.path.update_assessment_cycle_result,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            rid: parseInt(this.resetAssessmentForm.rid),
            assessmentType: this.resetAssessmentForm.assessmentType,
            assessmentResultDate: this.resetAssessmentForm.assessmentResultDate
          },
        })
        this.resetAssessmentLoading = false
        if (res.code === 0) {
          this.$message.success('重置考核状态成功')
        } else {
          this.$message.error(res.msg || res.message || '重置考核状态失败')
        }
      }).catch(() => { })
    },
    onClearResetAssessment() {
      this.resetAssessmentForm = this.$options.data().resetAssessmentForm
    },
    async onUpdateUserSource() {
      if (this.userSourceLoading) return
      if (!this.userSourceForm.rid) {
        this.$message.warning('请输入用户rid')
        return
      }
      if (!this.userSourceForm.source) {
        this.$message.warning('请输入推广来源')
        return
      }
      if (!this.userSourceForm.medium) {
        this.$message.warning('请输入推广媒介')
        return
      }

      this.$confirm('确认修改用户来源吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.userSourceLoading = true
        const { data: res } = await this.$axios({
          method: 'post',
          url: this.$store.getters.path.update_user_source,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            rid: parseInt(this.userSourceForm.rid),
            source: this.userSourceForm.source,
            medium: this.userSourceForm.medium
          },
        })
        this.userSourceLoading = false
        if (res.code === 0) {
          this.$message.success('用户来源修改成功')
        } else {
          this.$message.error(res.msg || res.message || '用户来源修改失败')
        }
      }).catch(() => { })
    },
    onClearUserSource() {
      this.userSourceForm = this.$options.data().userSourceForm
    }
  }
}
</script>
<style scoped lang="scss">
.common-test {
  &__title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  &__subtitle {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 30px;
  }

  .el-form {
    width: 600px;
  }

  // 标签页样式优化
  .el-tabs {
    .el-tabs__content {
      padding: 20px;
    }
    
    .el-card {
      border: none;
      box-shadow: none;
      
      .el-card__body {
        padding: 0;
      }
    }
  }
}
</style>